import { atom } from 'recoil';
// import { getUser } from '../service/auth'
import { Cookies } from 'react-cookie'

const cookies = new Cookies()

export const personState = atom({
  key: 'personState',
  default: {}
})

export const accessToken = atom({
  key: 'accessToken',
  default: cookies.get('user') ? cookies.get('user') : ''
})